import SEO from "../../../components/seo.jsx"
import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import TeamBg from "../../../assets/our-team.jpeg";

import drBhavesh from "../../../assets/drbhavesh.png";
import drIdris from "../../../assets/team/Dr-Idris.jpeg";
import drAjinkya from "../../../assets/team/dr-ajinkya.png";
import drPranay from "../../../assets/team/dr-pranay.jpeg";
import trilokSingh from "../../../assets/team/dr-trilok.jpg";
import dimpiSingh from "../../../assets/team/dr-dimpi-singh.jpg";
import sunitaPatil from "../../../assets/team/sunita-patil.jpg";

gsap.registerPlugin(ScrollTrigger);

const cinzel = { fontFamily: "'Cinzel', serif" };

/* ─────────────────────────────────────────────
   DATA
───────────────────────────────────────────── */
const doctors = [
  {
    img: drBhavesh,
    name: "Dr. Bhavesh Gupta",
    role: "Facial Cosmetic and Hair Transplant Surgeon",
    desc: "Well known for his artistic work in surgical hair transplant. He has done his masters in facial surgery and super specialization in cosmetic & hair transplant surgery from Mumbai. He is one of the most highly recommended hair transplant surgeons in India.",
  },
  {
    img: drIdris,
    name: "Dr. Idris MD",
    role: "Facial Cosmetic and Hair Transplant Surgeon",
    desc: "Facial cosmetic and hair transplant surgeon in Bangalore. Assistant Professor at NSVK College Bangalore. Director - Clinique Bangalore Division. Consultant Surgeon at GM-Apollo Hospital, Bangalore & 32 Smiles Chain, Bangalore.",
  },
  {
    img: drAjinkya,
    name: "Dr. Ajinkya Patil",
    role: "Facial Cosmetic and Hair Transplant Surgeon",
    desc: "A skilled facial cosmetic surgeon and hair transplant surgeon in Pune. He acquired his formal training with specialization in Cosmetic along with a specialization in Facio-Maxillary Surgery, with a keen aesthetic eye for transplant design.",
  },
  {
    img: drPranay,
    name: "Dr. Pranay Thakur",
    role: "Facial Cosmetic and Hair Transplant Surgeon",
    desc: "A skilled facial cosmetic surgeon and hair transplant surgeon in Shirdi. He acquired his formal medical along with a specialization in Facio-Maxillary Surgery, with superb surgical skills and a keen aesthetic eye.",
  },
];

const technicians = [
  {
    img: trilokSingh,
    name: "Trilok Singh",
    role: "Hair Technician",
    desc: "He is the first hair transplant technician of our team and has constantly thrived to give his best in each and every care done at our centre so far.",
  },
  {
    img: dimpiSingh,
    name: "Dimpi Singh",
    role: "Hair Technician",
    desc: "She is also a part of our team and she has a designated job to take care of the comfort of the patients, along with making sure the team completes every task within the allotted time frame.",
  },
  {
    img: sunitaPatil,
    name: "Sunita Patil",
    role: "Hair Technician",
    desc: "She is our third in-house technician and her job is to maintain the quality of graft dissection and graft storage.",
  },
];

/* ─────────────────────────────────────────────
   COMPONENT
───────────────────────────────────────────── */
export default function TeamPage({ url = "https://pune.hairclinique.in/our-Surgeons.php" }) {
  const pageRef        = useRef(null);
  const heroTextRef     = useRef(null);
  const docHeadRef      = useRef(null);
  const docCardsRef     = useRef([]);
  const techHeadRef     = useRef(null);
  const techCardsRef    = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const ease = "power3.out";

      gsap.fromTo(heroTextRef.current,
        { opacity: 0, y: 24 },
        { opacity: 1, y: 0, duration: 0.9, ease, delay: 0.1 }
      );

      const fadeUp = (el, trigger) => {
        if (!el) return;
        gsap.fromTo(el,
          { opacity: 0, y: 26 },
          { opacity: 1, y: 0, duration: 0.7, ease,
            scrollTrigger: { trigger: trigger || el, start: "top 88%", toggleActions: "play none none reverse" } }
        );
      };

      fadeUp(docHeadRef.current);
      fadeUp(techHeadRef.current);

      [docCardsRef, techCardsRef].forEach((group) => {
        group.current.forEach((el, i) => {
          if (!el) return;
          gsap.fromTo(el,
            { opacity: 0, y: 50, scale: 0.96 },
            { opacity: 1, y: 0, scale: 1, duration: 0.7, ease, delay: (i % 4) * 0.08,
              scrollTrigger: { trigger: el, start: "top 90%", toggleActions: "play none none reverse" } }
          );
        });
      });
    }, pageRef);
    return () => ctx.revert();
  }, []);

  return (
    <>
<SEO
  title="Meet Our Surgeons | Hair Transplant Team - Clinique Internationale"
  description="Meet the expert surgical team at Clinique Internationale, led by Dr. Ajinkya Patil, specializing in Sapphire FUE hair transplant across Mumbai, Pune, Kharghar & Shirdi."
  url={url}
/>
      <link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700;900&family=Raleway:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&display=swap" rel="stylesheet" />

      <div ref={pageRef} className="relative mt-20 lg:mt-30 w-full bg-[#0e0905] overflow-hidden font-['Raleway',sans-serif]">

        {/* ═══════════════════ BREADCRUMB HERO ═══════════════════ */}
        <div className="relative h-[400px] sm:h-[420px] md:h-[700px] flex items-center justify-center overflow-hidden">
  <img
    className="absolute inset-0 w-full h-full object-contain lg:object-cover object-top sm:object-center"
    src={TeamBg}
    alt="Clinique Internationale team background"
  />
          <div className="absolute inset-0 bg-linear-to-b from-[#0e0905]/5 to-[#0e0905]/85" />
          <div ref={heroTextRef} className="relative z-10 text-center px-6">
            <p style={cinzel} className="text-[11px] mt-70 tracking-[0.3em] uppercase text-[#c9a84c] mb-4 flex items-center justify-center gap-2.5">
              <span className="w-7 h-px bg-[#c9a84c]" />
              The People Behind Your Results
              <span className="w-7 h-px bg-[#c9a84c]" />
            </p>
            <h1 style={cinzel} className="font-black text-[2rem] sm:text-[2.6rem] md:text-[3.4rem] tracking-[0.04em] uppercase text-white mb-4">
              Meet Our Team
            </h1>
            <div style={cinzel} className="flex items-center justify-center gap-2.5 text-[12px] sm:text-[13px] tracking-[0.08em] uppercase text-white/60">
              <span className="text-white/85">Home</span>
              <span className="text-[#c9a84c]">/</span>
              <span className="text-[#c9a84c]">Our Team</span>
            </div>
          </div>
        </div>

        {/* ═══════════════════ DOCTORS ═══════════════════ */}
        <div className="max-w-6xl mx-auto px-5 sm:px-6 md:px-8 lg:px-12 py-16 sm:py-20 md:py-24">
          <div ref={docHeadRef} className="text-center mb-12 sm:mb-14">
            <p style={cinzel} className="text-[10.5px] tracking-[0.28em] uppercase text-[#c9a84c]/70 mb-3 flex items-center justify-center gap-2.5">
              <span className="w-6 h-px bg-[#c9a84c]/50" />
              Surgical Excellence
            </p>
            <h2 style={cinzel} className="font-black text-[1.5rem] sm:text-[1.9rem] md:text-[2.2rem] tracking-[0.04em] uppercase text-white">
              Partnered With The Finest Surgeons In Each City
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
            {doctors.map((d, i) => (
              <div
                key={d.name}
                ref={(el) => (docCardsRef.current[i] = el)}
                className="group relative rounded-2xl overflow-hidden bg-gradient-to-b from-white/[0.05] to-white/[0.02] border border-[#c9a84c]/[0.16] hover:border-[#c9a84c]/40 transition-all duration-300 hover:-translate-y-2 shadow-[0_8px_24px_rgba(0,0,0,0.35)]"
              >
                <span className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/45 to-transparent z-10" />
                <div className="relative h-[230px] sm:h-[260px] overflow-hidden">
                  <img
                    src={d.img}
                    alt={d.name}
                    className="w-full h-full object-contain lg:object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0e0905] via-transparent to-transparent" />
                </div>
                <div className="p-5 sm:p-6">
                  <p className="text-[10px] tracking-[0.1em] uppercase text-[#c9a84c]/75 italic mb-1.5">
                    {d.role}
                  </p>
                  <span className="block w-7 h-px bg-[#c9a84c]/50 mb-3" />
                  <h3 style={cinzel} className="text-[15px] sm:text-[16px] font-bold text-white tracking-[0.04em] mb-3">
                    {d.name}
                  </h3>
                  <p className="text-[12.5px] leading-[1.75] text-white/55">
                    {d.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ═══════════════════ TECHNICIANS ═══════════════════ */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-[#c9a84c]/25 to-transparent" />
        <div className="max-w-6xl mx-auto px-5 sm:px-6 md:px-8 lg:px-12 py-16 sm:py-20 md:py-24">
          <div ref={techHeadRef} className="text-center mb-12 sm:mb-14">
            <p style={cinzel} className="text-[10.5px] tracking-[0.28em] uppercase text-[#c9a84c]/70 mb-3 flex items-center justify-center gap-2.5">
              <span className="w-6 h-px bg-[#c9a84c]/50" />
              Hands That Make It Happen
            </p>
            <h2 style={cinzel} className="font-black text-[1.5rem] sm:text-[1.9rem] md:text-[2.2rem] tracking-[0.04em] uppercase text-white">
              Our In-House Hair Technicians
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 max-w-4xl mx-auto">
            {technicians.map((t, i) => (
              <div
                key={t.name}
                ref={(el) => (techCardsRef.current[i] = el)}
                className="group relative rounded-2xl overflow-hidden bg-gradient-to-b from-white/[0.05] to-white/[0.02] border border-[#c9a84c]/[0.16] hover:border-[#c9a84c]/40 transition-all duration-300 hover:-translate-y-2 shadow-[0_8px_24px_rgba(0,0,0,0.35)]"
              >
                <span className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#c9a84c]/45 to-transparent z-10" />
                <div className="relative h-[230px] sm:h-[250px] overflow-hidden">
                  <img
                    src={t.img}
                    alt={t.name}
                    className="w-full h-full object-contain lg:object-cover  grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0e0905] via-transparent to-transparent" />
                </div>
                <div className="p-5 sm:p-6">
                  <p className="text-[10px] tracking-[0.1em] uppercase text-[#c9a84c]/75 italic mb-1.5">
                    {t.role}
                  </p>
                  <span className="block w-7 h-px bg-[#c9a84c]/50 mb-3" />
                  <h3 style={cinzel} className="text-[15px] sm:text-[16px] font-bold text-white tracking-[0.04em] mb-3">
                    {t.name}
                  </h3>
                  <p className="text-[12.5px] leading-[1.75] text-white/55">
                    {t.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </>
  );
}